module.exports = __webpack_public_path__ + "img/support_c1.fd7410da.png";